import React from 'react'

const GrowthScoreCard = props => {
  return (
    <div>GrowthScoreCard</div>
  )
}


export default GrowthScoreCard